import { createAction, createSlice } from "@reduxjs/toolkit";

export const publishWorkflowRequest = createAction("workflowPublish/publishWorkflowRequest");

const initialState = {
  response: null,
  loading: false,
  error: null
};

const workflowPublishSlice = createSlice({
  name: "workflowPublish",
  initialState,
  reducers: {
    publishWorkflowStart(state) {
      state.loading = true;
      state.error = null;
    },
    publishWorkflowSuccess(state, action) {
      state.loading = false;
      state.response = action.payload || null;
      state.error = null;
    },
    publishWorkflowFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    clearWorkflowPublishState(state) {
      state.response = null;
      state.loading = false;
      state.error = null;
    }
  }
});

export const {
  publishWorkflowStart,
  publishWorkflowSuccess,
  publishWorkflowFailure,
  clearWorkflowPublishState
} = workflowPublishSlice.actions;

export default workflowPublishSlice.reducer;
